module.exports = __webpack_public_path__ + "media/images/top_ad-8f847e57f9a60b9bfcdab6f6b5a0b573.png";